/* eslint-disable no-console */
import { noop } from '@/common/utilities';

declare const GLOBAL_BUILD_PROFILE: `${'sportybet' | 'football' | 'universal'}-${'prod' | 'stage'}`;

const isProdEnv = GLOBAL_BUILD_PROFILE.includes('prod');

export const devLog = {
  log: isProdEnv
    ? noop
    : (message: string, ...args: any[]) => {
        console.log(message, ...args);
      },
  error: isProdEnv
    ? noop
    : (message: string, ...args: any[]) => {
        console.error(message, ...args);
      },
  warn: isProdEnv
    ? noop
    : (message: string, ...args: any[]) => {
        console.warn(message, ...args);
      },
  info: isProdEnv
    ? noop
    : (message: string, ...args: any[]) => {
        console.info(message, ...args);
      },
  debug: isProdEnv
    ? noop
    : (message: string, ...args: any[]) => {
        console.debug(message, ...args);
      },
};
